import {
  n1 as Map,
  z5 as interfaceMeta,
  ga as VOID,
  o6 as setMetadataFor,
  q1 as MutableMap,
  y9 as ensureNotNull,
  p5 as classMeta,
  e1 as ArrayList,
  y2 as last,
  i4 as toMutableSet,
  j4 as toSet,
  s9 as THROW_CCE,
  f3 as mapOf,
  n3 as mutableMapOf,
  y5 as hashCode,
  s5 as equals,
  e6 as isInterface,
  a2 as collectionSizeOrDefault,
  a1 as Unit_getInstance,
  z3 as setOf,
  o3 as mutableSetOf,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class MapNonNull {}
class MutableMapNonNull {}
class MutableMapNonNullDefault {
  constructor(map) {
    this.p4d_1 = map;
  }
  l3() {
    return this.p4d_1.l3();
  }
  j3() {
    return this.p4d_1.j3();
  }
  o() {
    return this.p4d_1.o();
  }
  k3() {
    return this.p4d_1.k3();
  }
  n1() {
    this.p4d_1.n1();
  }
  r3(key) {
    return this.p4d_1.r3(key);
  }
  s3(value) {
    return this.p4d_1.s3(value);
  }
  y() {
    return this.p4d_1.y();
  }
  m3(key, value) {
    return this.p4d_1.m3(key, value);
  }
  n3(from) {
    this.p4d_1.n3(from);
  }
  q3(key) {
    return this.p4d_1.q3(key);
  }
  u3(key) {
    return ensureNotNull(this.p4d_1.u3(key));
  }
}
class Stack {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.q4d_1 = tmp$ret$0;
    this.elements = this.q4d_1;
  }
  c29() {
    return this.elements;
  }
  clear() {
    this.q4d_1.n1();
  }
  push(element) {
    this.q4d_1.e1(element);
  }
  pop() {
    var v = last(this.q4d_1);
    this.q4d_1.a2(this.q4d_1.o() - 1 | 0);
    return v;
  }
  peek() {
    return last(this.q4d_1);
  }
}
class IteratorExportable {}
class MutableIteratorExportable {}
class IterableExportable {}
class MutableIterableExportable {}
class CollectionExportable {}
class MutableCollectionExportable {}
class IteratorExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  next() {
    return this.delegate.j1();
  }
  hasNext() {
    return this.delegate.h1();
  }
}
class MutableIteratorExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  remove() {
    return this.delegate.i1();
  }
  next() {
    return this.delegate.j1();
  }
  hasNext() {
    return this.delegate.h1();
  }
}
class CollectionExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o() {
    return this.delegate.o();
  }
  isEmpty() {
    return this.delegate.y();
  }
  iterator() {
    return get_exportable(this.delegate.u());
  }
  containsAll(elements) {
    return this.delegate.x(get_nonExportable_1(elements));
  }
  contains(element) {
    return this.delegate.w(element);
  }
  get size() {
    return this.o();
  }
}
class MutableCollectionExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o() {
    return this.delegate.o();
  }
  iterator() {
    return get_exportableM(this.delegate.u());
  }
  clear() {
    return this.delegate.n1();
  }
  retainAll(elements) {
    return this.delegate.m1(get_nonExportable_1(elements));
  }
  removeAll(elements) {
    return this.delegate.l1(get_nonExportable_1(elements));
  }
  addAll(elements) {
    return this.delegate.k1(get_nonExportable_1(elements));
  }
  remove(element) {
    return this.delegate.f1(element);
  }
  add(element) {
    return this.delegate.e1(element);
  }
  isEmpty() {
    return this.delegate.y();
  }
  containsAll(elements) {
    return this.delegate.x(get_nonExportable_1(elements));
  }
  contains(element) {
    return this.delegate.w(element);
  }
  get size() {
    return this.o();
  }
}
class Entry {}
class MapExportable {}
class MutableEntry {}
class MutableMapExportable {}
class EntryDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o3() {
    return this.delegate.o3();
  }
  p3() {
    return this.delegate.p3();
  }
  hashCode() {
    var tmp$ret$0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_hashCode = this.key;
    var tmp0_safe_receiver = tmp0_hashCode;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp$ret$0;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, Entry) : false)) {
      tmp = false;
    } else {
      tmp = equals(this.key, other.key);
    }
    return tmp;
  }
  get key() {
    return this.o3();
  }
  get value() {
    return this.p3();
  }
}
class MapExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o() {
    return this.delegate.o();
  }
  j3() {
    return get_exportable_2(this.delegate.j3());
  }
  k3() {
    return get_exportable_0(this.delegate.k3());
  }
  l3() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.delegate.l3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlinx.collections.MapExportableDefault.<get-entries>.<anonymous>' call
      tmp$ret$0 = new EntryDefault(item);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return get_exportable_2(toSet(tmp$ret$2));
  }
  isEmpty() {
    return this.delegate.y();
  }
  getOrDefault(key, defaultValue) {
    var tmp0_elvis_lhs = this.delegate.u3(key);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  containsValue(value) {
    return this.delegate.s3(value);
  }
  containsKey(key) {
    return this.delegate.r3(key);
  }
  get(key) {
    return this.delegate.u3(key);
  }
  get size() {
    return this.o();
  }
  get keys() {
    return this.j3();
  }
  get values() {
    return this.k3();
  }
  get entries() {
    return this.l3();
  }
}
class MutableEntryDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o3() {
    return this.delegate.o3();
  }
  p3() {
    return this.delegate.p3();
  }
  setValue(newValue) {
    return this.delegate.e8(newValue);
  }
  hashCode() {
    var tmp$ret$0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_hashCode = this.key;
    var tmp0_safe_receiver = tmp0_hashCode;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp$ret$0;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, Entry) : false)) {
      tmp = false;
    } else {
      tmp = equals(this.key, other.key);
    }
    return tmp;
  }
  get key() {
    return this.o3();
  }
  get value() {
    return this.p3();
  }
}
class MutableMapExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.delegate.l3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlinx.collections.MutableMapExportableDefault.entries.<anonymous>' call
      var tmp_0 = new MutableEntryDefault(item);
      tmp$ret$0 = isInterface(tmp_0, MutableEntry) ? tmp_0 : THROW_CCE();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.r4d_1 = get_exportableM_2(toMutableSet(tmp$ret$2));
    this.s4d_1 = get_exportableM_2(this.delegate.j3());
    this.t4d_1 = this.delegate.o();
    this.u4d_1 = get_exportableM_0(this.delegate.k3());
  }
  y2u() {
    return this.delegate;
  }
  l3() {
    return this.r4d_1;
  }
  j3() {
    return this.s4d_1;
  }
  o() {
    return this.t4d_1;
  }
  k3() {
    return this.u4d_1;
  }
  clear() {
    return this.delegate.n1();
  }
  isEmpty() {
    return this.delegate.y();
  }
  get(key) {
    return this.delegate.u3(key);
  }
  put(key, value) {
    return this.delegate.m3(key, value);
  }
  set(key, value) {
    var tmp0_set = this.delegate;
    tmp0_set.m3(key, value);
    return Unit_getInstance();
  }
  remove(key) {
    return this.delegate.q3(key);
  }
  putAll(from) {
    return this.delegate.n3(get_nonExportable_3(from));
  }
  containsKey(key) {
    return this.delegate.r3(key);
  }
  containsValue(value) {
    return this.delegate.s3(value);
  }
  getOrDefault(key, defaultValue) {
    var tmp0_elvis_lhs = this.delegate.u3(key);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  get entries() {
    return this.l3();
  }
  get keys() {
    return this.j3();
  }
  get size() {
    return this.o();
  }
  get values() {
    return this.k3();
  }
}
class SetExportable {}
class MutableSetExportable {}
class SetExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o() {
    return this.delegate.o();
  }
  isEmpty() {
    return this.delegate.y();
  }
  iterator() {
    return get_exportable(this.delegate.u());
  }
  containsAll(elements) {
    return this.delegate.x(get_nonExportable_1(elements));
  }
  contains(element) {
    return this.delegate.w(element);
  }
  get size() {
    return this.o();
  }
}
class MutableSetExportableDefault {
  constructor(delegate) {
    this.delegate = delegate;
  }
  y2u() {
    return this.delegate;
  }
  o() {
    return this.delegate.o();
  }
  iterator() {
    return get_exportableM(this.delegate.u());
  }
  clear() {
    return this.delegate.n1();
  }
  retainAll(elements) {
    return this.delegate.m1(get_nonExportable_1(elements));
  }
  removeAll(elements) {
    return this.delegate.l1(get_nonExportable_1(elements));
  }
  addAll(elements) {
    return this.delegate.k1(get_nonExportable_1(elements));
  }
  remove(element) {
    return this.delegate.f1(element);
  }
  add(element) {
    return this.delegate.e1(element);
  }
  isEmpty() {
    return this.delegate.y();
  }
  containsAll(elements) {
    return this.delegate.x(get_nonExportable_1(elements));
  }
  contains(element) {
    return this.delegate.w(element);
  }
  get size() {
    return this.o();
  }
}
//endregion
function transitveClosure(_this__u8e3s4, function_0) {
  var result = toMutableSet(_this__u8e3s4);
  var newThings = toMutableSet(_this__u8e3s4);
  var newStuff = true;
  while (newStuff) {
    var temp = toSet(newThings);
    newThings.n1();
    var tmp0_iterator = temp.u();
    while (tmp0_iterator.h1()) {
      var nt = tmp0_iterator.j1();
      var s = function_0(nt);
      newThings.k1(s);
    }
    newThings.l1(result);
    newStuff = result.k1(newThings);
  }
  return result;
}
function get_exportable(_this__u8e3s4) {
  return new IteratorExportableDefault(_this__u8e3s4);
}
function get_nonExportable(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof IteratorExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportableM(_this__u8e3s4) {
  return new MutableIteratorExportableDefault(_this__u8e3s4);
}
function get_nonExportable_0(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof MutableIteratorExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportable_0(_this__u8e3s4) {
  return new CollectionExportableDefault(_this__u8e3s4);
}
function get_nonExportable_1(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof CollectionExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportableM_0(_this__u8e3s4) {
  return new MutableCollectionExportableDefault(_this__u8e3s4);
}
function get_nonExportable_2(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof MutableCollectionExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportable_1(_this__u8e3s4) {
  return new MapExportableDefault(_this__u8e3s4);
}
function get_nonExportable_3(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof MapExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportableM_1(_this__u8e3s4) {
  return new MutableMapExportableDefault(_this__u8e3s4);
}
function get_nonExportable_4(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof MutableMapExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function mapExportableOf(pairs) {
  return new MapExportableDefault(mapOf(pairs.slice()));
}
function mutableMapExportableOf(pairs) {
  return new MutableMapExportableDefault(mutableMapOf(pairs.slice()));
}
function get_exportable_2(_this__u8e3s4) {
  return new SetExportableDefault(_this__u8e3s4);
}
function get_nonExportable_5(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof SetExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function get_exportableM_2(_this__u8e3s4) {
  return new MutableSetExportableDefault(_this__u8e3s4);
}
function get_nonExportable_6(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof MutableSetExportableDefault ? _this__u8e3s4 : THROW_CCE()).delegate;
}
function exportableSetOf(elements) {
  return new SetExportableDefault(setOf(elements.slice()));
}
function mutableExportableSetOf(elements) {
  return new MutableSetExportableDefault(mutableSetOf(elements.slice()));
}
//region block: post-declaration
setMetadataFor(MapNonNull, 'MapNonNull', interfaceMeta, VOID, [Map]);
setMetadataFor(MutableMapNonNull, 'MutableMapNonNull', interfaceMeta, VOID, [MapNonNull, MutableMap]);
setMetadataFor(MutableMapNonNullDefault, 'MutableMapNonNullDefault', classMeta, VOID, [MutableMapNonNull, MutableMap]);
setMetadataFor(Stack, 'Stack', classMeta);
setMetadataFor(IteratorExportable, 'IteratorExportable', interfaceMeta);
setMetadataFor(MutableIteratorExportable, 'MutableIteratorExportable', interfaceMeta, VOID, [IteratorExportable]);
setMetadataFor(IterableExportable, 'IterableExportable', interfaceMeta);
setMetadataFor(MutableIterableExportable, 'MutableIterableExportable', interfaceMeta, VOID, [IterableExportable]);
setMetadataFor(CollectionExportable, 'CollectionExportable', interfaceMeta, VOID, [IterableExportable]);
setMetadataFor(MutableCollectionExportable, 'MutableCollectionExportable', interfaceMeta, VOID, [CollectionExportable, MutableIterableExportable]);
setMetadataFor(IteratorExportableDefault, 'IteratorExportableDefault', classMeta, VOID, [IteratorExportable]);
setMetadataFor(MutableIteratorExportableDefault, 'MutableIteratorExportableDefault', classMeta, VOID, [MutableIteratorExportable]);
setMetadataFor(CollectionExportableDefault, 'CollectionExportableDefault', classMeta, VOID, [CollectionExportable]);
setMetadataFor(MutableCollectionExportableDefault, 'MutableCollectionExportableDefault', classMeta, VOID, [MutableCollectionExportable]);
setMetadataFor(Entry, 'Entry', interfaceMeta);
setMetadataFor(MapExportable, 'MapExportable', interfaceMeta);
setMetadataFor(MutableEntry, 'MutableEntry', interfaceMeta, VOID, [Entry]);
setMetadataFor(MutableMapExportable, 'MutableMapExportable', interfaceMeta, VOID, [MapExportable]);
setMetadataFor(EntryDefault, 'EntryDefault', classMeta, VOID, [Entry]);
setMetadataFor(MapExportableDefault, 'MapExportableDefault', classMeta, VOID, [MapExportable]);
setMetadataFor(MutableEntryDefault, 'MutableEntryDefault', classMeta, VOID, [MutableEntry]);
setMetadataFor(MutableMapExportableDefault, 'MutableMapExportableDefault', classMeta, VOID, [MutableMapExportable]);
setMetadataFor(SetExportable, 'SetExportable', interfaceMeta, VOID, [CollectionExportable]);
setMetadataFor(MutableSetExportable, 'MutableSetExportable', interfaceMeta, VOID, [SetExportable, MutableCollectionExportable]);
setMetadataFor(SetExportableDefault, 'SetExportableDefault', classMeta, VOID, [SetExportable]);
setMetadataFor(MutableSetExportableDefault, 'MutableSetExportableDefault', classMeta, VOID, [MutableSetExportable]);
//endregion
//region block: exports
MapExportableDefault.EntryDefault = EntryDefault;
MutableMapExportableDefault.MutableEntryDefault = MutableEntryDefault;
export {
  MutableMapNonNullDefault,
  Stack,
  transitveClosure,
  IteratorExportableDefault,
  MutableIteratorExportableDefault,
  CollectionExportableDefault,
  MutableCollectionExportableDefault,
  mapExportableOf,
  mutableMapExportableOf,
  MapExportableDefault,
  MutableMapExportableDefault,
  exportableSetOf,
  mutableExportableSetOf,
  SetExportableDefault,
  MutableSetExportableDefault,
};
export {
  Stack as a,
  get_exportableM_1 as b,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlinx-kotlinx-collections.mjs.map
